import { useEffect, useState, useRef, createContext, useContext, CSSProperties } from 'react'
import React from 'react'
import { IDrillThruPayloadState, useExportDrillThruMutation, useSetDrillThruDefaultMutation, useSubmitFormMutation } from '../../Redux/DrillThru/DrillThruSlice'
// import HighTextDrillThru from './HighTextDrillThru'
import { IDrillthruResponse } from '../../Redux/DrillThru/DrillThruSlice'
// import { FoundationsSelect } from '../../GenericComponents/select'
// import DrillThruTableRow from './DrillThruTableRow'
// import { ImdsColumnKeys } from './DrillThruItems/DrillThruTypes'
import ReactSelectDropdown, { ReactSelect_LightMode, ReactSelect_DarkMode } from '../ReactSelect'
import { useDispatch, useSelector } from 'react-redux'
import { getReportVUInfo, IVUDataObj, SetVudata } from '../../Redux/VisualUnits/visualUnitStateSlice'
import ReportStackTraceBlock from '../StackTraceMessage/ReportStackTraceBlock'
import { getBaseUrl } from '../../Utils'
import { IMetadataDrillThruSet, useSetViewMutation } from '../../Redux/VisualUnits/visualUnitAPISlice'
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { FoundationsConstants } from '../../FoundationsConstants'
import HandleAnyPopupMessage from '../handleAnyPopupMessage'
import { useStatPortalIdContext } from '../StatCase/StatCaseFormHooks/StatPortalIdContext'
import useStickyHeader from '../../Hooks/useStickyHeader'
import LinkSetup from './DrillThruItems/LinkSetup'
import { DrillThruComponentType, ImdsColumnKeys } from './DrillThruItems/DrillThruTypes'
import OCVDialog from '../OCV/OCVDialog'
import { setLmsId, setnewForm } from '../../Redux/LeaveManager/LmsIdSlice'
import Sortable from 'sortablejs';
import { Skeleton } from '../../GenericComponents/Skeleton'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { SummaryReportContext } from '../SummaryTiles/Summary'
import { useZustandVisualUnitStore } from '../Reports/vuContext'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import FoundationsSelect from '../../GenericComponents/select'
import { FoundationsOptionType, FoundationsSelectType } from '../../Types/FoundationsTypes'
import AutoRefreshTimer from './AutoRefreshTimer'
import DrillThruGlobalSearch from './DrillThruGlobalSearch'
import { getDurationDisplayFromSecs } from '../Charts/chartHelperFunctions'

declare let window: any

interface drillThruProps {
    reportData: any
    text: boolean
    isPageView: boolean
    componentName: string
    Id: number
    isDrillThruAllowed: boolean
    onLoadComplete?: (status: boolean) => void
}
interface SortColumn {
    value: string;
    name: string;
    disabled: boolean;
    selected: boolean
}
interface IDrillThruObject {
    drillThruSetId: number | string
    olddrillThruSetId: string | number
    vuId: number
    vuTempId: string | number
    dashBoardId: string | number
    cellId: string | number
    cellValue: string | number
    pageSize: string | number
    drillThruDP: string | number
    drillThruSearchString: string | number
    InputSearchList: string[]
    drillThruActionType: string | number
    pageNumber: string | number
    callerType: string
}

interface IButtons {
    save: boolean
    buildQuery: boolean
    redraw: boolean
    btnExport: boolean
}
interface IMdscOrderById {
    mdscId: string,
    displayOrder: number
}
export interface IVUobjectData {
    data_drillThruMode: string | number
    data_vuTempId: number
    data_drillCellId: string | number
    data_drillCellValue: string | number
    data_drillPageSize: string
    data_drillPageNumber: string
    data_drillThruSearch: string | number | undefined
    data_drillThruDP: IDrillThruDp
    data_drillThruSearchObj: string | number
    data_vuDetails: any
    mdscorderbyid: IMdscOrderById[]
    Data_SortColumn: any[] | null,
    data_drillThruSetId: number,
    data_isSearched: boolean
}
interface IDrillThruDp {
    meId: number | string
    vuDeId: string | number
    dimDPs: any[]
    sortColumns: any
    vuId: any
}
//TODO:
//this.model.getMeasureList
//MDS
export interface ISortColumn {
    Id: number
    MetaDataDrillThruSetId: any
    MetaDataId: number
    DataType: any
    FieldName: string
    DisplayOrder: number
    TableName: any
    ColumnName: string
    JavascriptTarget: any
    javascriptTargetParams: any
    SortOrder: 'asc' | 'desc'
    IsSortable: boolean
    hideInDrillThru: boolean
    AllowedPrivileges: any
}
export const getDrillThruVUObject = () => {
    var runDrillVU: any = {}
    runDrillVU.vuId = -1
    runDrillVU.vuTempId = -1
    runDrillVU.isAsync = true
    runDrillVU.cellId = ''
    runDrillVU.cellValue = ''
    runDrillVU.cellValueseriesName = ''
    runDrillVU.cellValuecategoryName = ''
    runDrillVU.vudetails = -1
    runDrillVU.pageSize = 10
    runDrillVU.pageNumber = 1
    runDrillVU.drillThruDP = null
    runDrillVU.isSummaryReport = false
    runDrillVU.drillThruSetId = -1
    return runDrillVU
}

export const DrillThruTableConetext = createContext<any>(null);
interface IExportDrillthruMsg {
    exportMessage: string,
    exportLink: string,
    linkText: string
}

const DrillThru = (props: {
    executeResultData: any
    dashBoardId: number
    initialPayload?: any
    reportData?: any
    inline?: any
    actionMode?: any
    measureName?: any
    dataExplore?: any
    dataExplor?: any
    autoRefreshInterval?: any
    data_is_summary?: any
    ishelprequest?: any
    engineType?: any
    ViewerType?: any
    onLoadComplete?: any
    isEnabledAutoNavigation: boolean
    closeDrillThru: () => void
    onDrillThruLoaded?: any
}) => {
    let {
        executeResultData,
        dashBoardId,
        initialPayload,
        reportData,
        inline,
        actionMode,
        measureName,
        dataExplore,
        autoRefreshInterval,
        data_is_summary,
        ishelprequest,
        engineType,
        ViewerType,
        onLoadComplete,
        isEnabledAutoNavigation,
        closeDrillThru,
        onDrillThruLoaded,
    } = props
        
    const vuDetails: VisualUnitApiDTO_VisualUnit | null = useZustandVisualUnitStore((s) => s.vuState)

    if(!vuDetails){
        console.error("Dangling Drillthru. No Visualunit is attached to it.")
        return <div>Unexpected error of not receiving Visualunit with drillthru</div>
    }

    const buttonRef = useRef<HTMLButtonElement>(null)
    let dispatch = useDispatch()
    let vuId = reportData?.id
    //MeasureName

    const [callDrillThru, { data: drillThruReducer, isLoading: drillThruLoadingState, isError: drillThruAPIError }] = useSubmitFormMutation()
    const [callSetViewAPI] = useSetViewMutation()
    const [callExportDrillThru] = useExportDrillThruMutation()
    const [callSetDrillThruSetDefaultForMeasure] = useSetDrillThruDefaultMutation()
    let vuDataObj: IVUDataObj = useSelector(getReportVUInfo)[vuId] || null
    const [featureList, setFeatureList] = useState([])
    const [stackTraceMessage, setStackTraceMessage] = useState<string>('')
    const [throwError, setThrowError] = useState<boolean>(false)
    const [drillThruInfo, setDrillThruInfo] = useState({})
    const [mdsColumnByColName, setMDSColumnByColName] = useState({})
    const [sortedColumnName, setSortedColumnName] = useState<string>('')
    const [sortVal, setSortVal] = useState<string[]>([])
    const [appentSortvalidtion, setAppentSortvalidtion] = useState<boolean>(false)
    const [sortColList, setSortColList] = useState<FoundationsOptionType[]>([]);
    const [sortOptionVisible, setSortOptionVisible] = useState<boolean>(false)
    const [showSortDropDown, setShowSortDropDown] = useState<boolean>(false)
    const [enableGlobalSearch, setEnableGlobalSearch] = useState<boolean>(false)
    const [drillThruDataAsJson, setDrillThroughDataAsJSON] = useState([])
    const [requestedDrillThruData, setRequestedDrillThruData] = useState([])
    const [sortColumnsList, setSortColumnsList] = useState([])
    const [tHeaders, setTheaders] = useState<string[]>([])
    const [mdsColumData, setMDSColumData] = useState<any[]>([])
    const [mdsColumn, setMDSColumn] = useState<any>({})
    const [drillThruSets, setDrillThruSets] = useState<any[]>([])
    const [drillThruLinkSeqList, setDrillThruLinkSeqList] = useState<number[]>([])
    const [drillThruSetID, setDrillThruSetID] = useState<number | null>(null)
    const [showRefreshStatus, setShowRefreshStatus] = useState({
        right: '40px',
        display: 'none',
        cursor: 'default',
        position: 'absolute',
        fontWeight: 'bold',
        color: '#919191',
        fontSize: '20px',
        lineHeight: '24px',
    })
    const [selectedDrillthruSet, setSelectedDrillThruSet] = useState<FoundationsOptionType[]>([])
    const [oldDrillThruSetID, setOldDrillThruSetId] = useState<number | string>(-1)
    const [toggleDrill, setToggleDrill] = useState<boolean>(false)
    const [drillData, setDrillData] = useState({})
    const [cellValue, setCellValue] = useState<string>('')
    const [drillThruData, setDrillThruData] = useState<any[]>([])
    const [isDrillThruApplicable, setIsDrillThruApplicable] = useState<boolean>(true)
    const [buttonState, setButtonState] = useState<IButtons>({
        save: false,
        buildQuery: false,
        redraw: false,
        btnExport: false,
    })
    const [configColor] = useState<boolean>(false)
    const [activeDrillRow, setActiveDrillRow] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(true)
    const [inlineLoader, setInlineLoader] = useState<boolean>(false)
    const [displayRefreshPanel, setDisplayRefreshPanel] = useState<boolean>(false)
    // let initialTime = autoRefreshInterval * 60 || 0
    
    const [changeOpacity, setChangeOpacity] = useState(1)
    const [searchedTextIDs, setSearchedTextIDs] = useState<any>({})
    const [paginationString, setPaginationString] = useState<string | number | undefined>(undefined)
    const [firstPage, setFirstPage] = useState<boolean>(true)
    const [lastPage, setLastPage] = useState<boolean>(false)
    const [isStartedAutoRefresh, setIsStartedAutoRefresh] = useState<boolean>(false)
    const [JSONRowDataLists, setJSONRowDataLists] = useState({
        sortColumnsData: [],
        jsonRowEncrypyedList: [],
        jsonRowList: [],
        featureList: [],
    } as {
        sortColumnsData: any[],
        jsonRowEncrypyedList: any[],
        jsonRowList: any[],
        featureList: any[],
    })
    const [sortColumnOrder, setSortColumnOrder] = useState<any>({})
    const { setStatPortalId, setSelectedAccessionNumber, setSelectedVuId, setAction } = useStatPortalIdContext();
    const exportPopupMessage = useRef<IExportDrillthruMsg>({
        exportMessage: '',
        exportLink: "",
        linkText: ""
    })
    const [showExportPopup, setShowExportPopup] = useState(false)
    const [DrillThruRefreshed, setDrillThruRefreshed] = useState(false)
    const [DrillThruTableHeaderOrder, setDrillThruTableHeaderOrder] = useState<any[]>([])
    const drillThruObjRef = useRef<IVUobjectData>({
        data_drillThruMode: '',
        data_vuTempId: -1,
        data_drillCellId: '',
        data_drillCellValue: '',
        data_drillPageSize: '',
        data_drillPageNumber: '1',
        data_drillThruSearch: undefined,
        data_drillThruDP: { meId: '', vuDeId: '', dimDPs: [], sortColumns: [], vuId: '' },
        data_drillThruSearchObj: '',
        data_vuDetails: '',
        mdscorderbyid: [],
        Data_SortColumn: [],
        data_drillThruSetId: -1,
        data_isSearched: false,
    });
    const { forceUpdate } = useStatPortalIdContext();
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))

    const updateRefState = (updatedData: Partial<IVUobjectData>) => {
        drillThruObjRef.current = { ...drillThruObjRef.current, ...updatedData }
    }

    useEffect(() => {
        if (onLoadComplete) { //without this check dril thru's are failing..
            onLoadComplete(loading || throwError)
        }
    }, [loading, throwError]);

    const openHighTextDrillRow = (
        rowData: any,
        rowIndex: number,
        JSONrowDataList: {
            sortColumnsData: any[],
            jsonRowEncrypyedList: any[],
            jsonRowList: any[],
            featureList: any[],
        }= {
            sortColumnsData: [],
            jsonRowEncrypyedList: [],
            jsonRowList: [],
            featureList: [],
        }
    ) => {
        if (rowIndex === activeDrillRow) {
            // Toggle visibility if clicking the same row
            setToggleDrill(prev => !prev);
        } else {
            // Always open drill for a new row
            setToggleDrill(true);
            setActiveDrillRow(rowIndex);
        }
    
        // Always update the data regardless of toggle state
        setMDSColumn(mdsColumData[rowIndex]);
        setDrillData(rowData);
        setJSONRowDataLists(JSONrowDataList);
    };
    const getJSONRowDataLists= (jsonRow: { [s:string]:any }, sortColumnsList: any[]) => {
        var jsonRowEncrypyedList = [] as any[];
        var sortColumnsData = {} as { [s: string]: any };
        var jsonRowList = [] as any[];
        for (var colKey in jsonRow) {
            if (colKey == "TotalRows") continue;
            if (jsonRow.hasOwnProperty(colKey)) {
                //check if the jsonRow[colKey] has a Json Object and push the normal value from that object;
                if (typeof (jsonRow[colKey]) == "object") {
                    let jsonRowEncrypyedObject = {} as {[s:string]:any};
                    jsonRowEncrypyedObject.EncryptedKey = jsonRow[colKey].EncryptedKey;
                    jsonRowEncrypyedObject.Title = 'SmartObject Viewer';
                    if (jsonRow[colKey].Title != undefined && jsonRow[colKey].Title != "") {
                        jsonRowEncrypyedObject.Title = jsonRow[colKey].Title;
                    }
                    jsonRowEncrypyedList.push(jsonRowEncrypyedObject);
                    jsonRowList.push(jsonRow[colKey].Key);
                    jsonRow[colKey] = jsonRow[colKey].Key;
                }
                else {
                    jsonRowList.push(jsonRow[colKey]);
                    jsonRowEncrypyedList.push(null);
                }
                if (sortColumnsList && jsonRow.hasOwnProperty(colKey)) {
                    sortColumnsList.forEach(function(tempSortColumn)
                    {
                        if (tempSortColumn.FieldName == colKey)
                            sortColumnsData[colKey] = jsonRow[colKey];
                });
                }
                //jsonRowEncrypyedList.push(jsonRow[colKey]) if nothing push a NULL else push the enrypted value;
            }
        }
        return [jsonRow, jsonRowList, jsonRowEncrypyedList, sortColumnsData] as any[];
    }
   

    // const SummaryReportContextValues = useContext(SummaryReportContext);
    
    // const TableReportAutoRefreshInterval = vuDetails.RefreshInterval;
    // // const {SummaryReportAutoRefreshInterval} = SummaryReportContextValues || {};
    // const [localRefreshInterval, setLocalRefreshInterval] = useState(autoRefreshInterval);

    // // You this useEffect if you want to manipulate values from TableReport and summary reports only.
    // useEffect(() => {
    //     if (TableReportAutoRefreshInterval !== undefined) {
    //         setLocalRefreshInterval(TableReportAutoRefreshInterval);
    //     }
    //     // if (SummaryReportAutoRefreshInterval !== undefined) {
    //     //     setLocalRefreshInterval(SummaryReportAutoRefreshInterval);
    //     // }
    // }, [TableReportAutoRefreshInterval]);
    // // }, [TableReportAutoRefreshInterval, SummaryReportAutoRefreshInterval]);

    // useEffect(() => {
    //     const TriggerIntervalValueMilliseconds =  localRefreshInterval * 60 * 1000;
    //     // startDrillthruAutoRefreshClock()
    //     // var refreshInterval = autoRefreshInterval * 60 * 1000;
    //     // var isvisible = false;

    //     if (!refreshPaused && localRefreshInterval > 0) {
    //         var refreshTimerHandle = setInterval(() => {
    //             refreshDrillThru(
    //                                 vuId,
    //                                 drillThruObjRef.current.data_vuTempId,
    //                                 FoundationsConstants.enumVUCallerType.AutoRefresh,
    //                                 null,
    //                                 false,
    //                                 null,
    //                                 null,
    //                                 true
    //                             )
                
    //         }, TriggerIntervalValueMilliseconds) // Convert minutes to milliseconds
    //         return () => {
    //             clearInterval(refreshTimerHandle)
    //         }
    //     }
    // }, [refreshPaused, localRefreshInterval, vuId, drillThruObjRef])

    const disableButtons = ([...buttons], isDisable: boolean) => {
        //provides button dynamic id as a attribute to functions.
        buttons.map((itr, ind) => {
            return setButtonState((prevState) => ({ ...prevState, [itr]: isDisable }))
        })
    }
    const enableButtons = () => { }

    const changeDrillThruSet = (val: FoundationsOptionType) => {
        setSelectedDrillThruSet([val]) //its a single select so need single value only
        let cellId = drillThruObjRef.current.data_drillCellId
        let cellValue = drillThruObjRef.current.data_drillCellValue
        let pageSize = parseInt(drillThruObjRef.current.data_drillPageSize)
        let pageNumber = parseInt(drillThruObjRef.current.data_drillPageNumber)
        let drillThruDP = drillThruObjRef.current.data_drillThruDP
        let newDrillThruSetId = parseInt(val.value)
        let olddrillThruSetId = drillThruReducer?.data.drillThruSetId
        setOldDrillThruSetId(olddrillThruSetId)
        let vuTempId = -1
        let isExplore = dataExplore === 'yes' ? true : false
        if (isExplore) {
            vuTempId = drillThruObjRef.current.data_vuTempId
        }

        setDrillThruSetID(newDrillThruSetId)

        let reqDrillThruData: any = {}
        reqDrillThruData.dashBoardId = dashBoardId
        reqDrillThruData.vuId = vuId
        reqDrillThruData.vuTempId = vuTempId
        reqDrillThruData.cellId = cellId
        reqDrillThruData.cellValue = cellValue
        reqDrillThruData.pageSize = pageSize
        reqDrillThruData.pageNumber = pageNumber
        reqDrillThruData.drillThruDP = drillThruDP
        reqDrillThruData.drillThruSetId = newDrillThruSetId
        reqDrillThruData.drillThruSearchString = ''
        reqDrillThruData.drillThruActionType = 'changedrillthruset'
        reqDrillThruData.InputSearchList = null
        reqDrillThruData.olddrillThruSetId = olddrillThruSetId

        toggleDrillThruLoader(false, true, reqDrillThruData.drillThruActionType)
        drillThruVisualUnitData(
            reqDrillThruData,
            reqDrillThruData.drillThruActionType,
            true,
            '',
            ishelprequest
        )
    }

    //DrillThru_Bug_Fixes - startDrillthruAutoRefreshClock handled once component launches, All timer related functionality is handled in AutoRefreshTimer component

    const jumpDrillPage = (vuId: number, jumpType: string, inline: boolean) => {
        //let vuDrillDataObj = $("#vu_table_drill_" + vuId);
        let cellId = drillThruObjRef.current.data_drillCellId
        let cellValue = drillThruObjRef.current.data_drillCellValue
        let pageSize = parseInt(drillThruObjRef.current.data_drillPageSize)
        let pageNumber = parseInt(drillThruObjRef.current.data_drillPageNumber)
        let rowCount = drillThruReducer?.data.rowCount
        let drillThruDP = drillThruObjRef.current.data_drillThruDP
        let drillThruSetId = drillThruReducer?.data.drillThruSetId
        let drillThruSearchString = drillThruObjRef.current.data_drillThruSearch
        let InputSearchList = drillThruObjRef.current.data_drillThruSearchObj
        let totalPages = Math.ceil(rowCount / pageSize)
        let newPageNumber = pageNumber + (jumpType === 'previous' ? -1 : 1)
        if (newPageNumber <= 1 || newPageNumber > totalPages) {
            newPageNumber = 1
        }
        updateRefState({ data_drillPageNumber: newPageNumber.toString() })

        let vuTempId = -1
        let isExplore = dataExplore === 'yes' ? true : false
        if (isExplore) {
            vuTempId = drillThruObjRef.current.data_vuTempId
        }

        let reqDrillThruData: any = {}
        reqDrillThruData.dashBoardId = dashBoardId
        reqDrillThruData.vuId = vuId
        reqDrillThruData.vuTempId = vuTempId
        reqDrillThruData.cellId = cellId
        reqDrillThruData.cellValue = cellValue
        reqDrillThruData.pageSize = pageSize
        reqDrillThruData.pageNumber = newPageNumber
        reqDrillThruData.drillThruDP = drillThruDP
        reqDrillThruData.drillThruSetId = drillThruSetId
        reqDrillThruData.drillThruSearchString = drillThruSearchString
        reqDrillThruData.InputSearchList = InputSearchList
        reqDrillThruData.drillThruActionType = 'dt_paginate'
        toggleDrillThruLoader(false, true)
        drillThruVisualUnitData(reqDrillThruData, 'dt_paginate', inline, '', ishelprequest)
    }

    const refreshDrillThru = (
        vuId: number,
        vuTempId: string | number | undefined,
        callerType: string,
        measureDataPoint: any[] | null,
        clickedRefresh = false,
        drillthrudp: IDrillThruDp | null = null,
        drillthrumode: string | null = null,
        applySort = false,
    ) => {
        //startDrillthruAutoRefreshClock(0) handled in Drillthru api. as per paylodActionTypes
        let count
        let mindxes: any
        let cellIdRefresh = drillThruObjRef.current.data_drillCellId
        let ishelprequest = false
        if (drillthrumode == 'AFHDrillThru') {
            ishelprequest = true
        }
        //drillThruDP
        if (clickedRefresh != true) {
            try {
                mindxes = vuDetails?.MeasureList.findIndex(function (x: {
                    MetaDataId: string | number
                    DetailId: string | number
                }) {
                    return x.MetaDataId == drillthrudp?.meId && x?.DetailId == drillthrudp.vuDeId
                })
            } catch (err) {
                console.error('error1')
            }

            if (measureDataPoint != null) {
                if (measureDataPoint.length == 1) {
                    count = measureDataPoint[0]
                } else {
                    count = measureDataPoint[mindxes]
                }
            }
        }

        let viewerType = ViewerType
        if (
            (clickedRefresh == true || callerType == FoundationsConstants.enumVUCallerType.AutoRefresh) &&
            (viewerType == 1 || ishelprequest)
        ) {
            let reqRunVUData = {
                visualUnitId: vuId,
                dashBoardId: dashBoardId,
                isAsync: false,
                viewerType: ishelprequest ? 2 : viewerType,
                callerType: callerType,
                pageSize: 10,
                pageNumber: 1,
                sortColumn: '',
                sortOrder: '',
                forceRefresh: 1,
                viewerTypeChanged: false,
            }

            let oldviewerType = viewerType
            if (oldviewerType != undefined && oldviewerType != reqRunVUData.viewerType) {
                reqRunVUData.viewerTypeChanged = true
            }
        }

        let measureVal1 = ''
        let cellValueRefresh = count != null ? count : drillThruObjRef.current.data_drillCellValue
        let pageSize = parseInt(drillThruObjRef.current.data_drillPageSize)
        let pageNumber = parseInt(drillThruObjRef.current.data_drillPageNumber)
        let drillThruDPRefresh: any = JSON.stringify(drillThruObjRef.current.data_drillThruDP) //creating deep copy..
        let drillThruSetIdRefresh = drillThruReducer?.data.drillThruSetId
        let drillThruSearchString = drillThruObjRef.current.data_drillThruSearch || undefined
        let parsedDPRefresh = JSON.parse(drillThruDPRefresh)
        if (applySort) {
            if (Array.isArray(parsedDPRefresh?.sortColumns) && parsedDPRefresh?.sortColumns?.length === 0) {
                //Keeping applied sort when set view is called. If no sort is applied setting sortcolumns to null
                parsedDPRefresh.sortColumns = null
            }
        } else {
            if (parsedDPRefresh !== undefined && parsedDPRefresh !== null) {
                //FP-9323. Added undefined and null  check.
                parsedDPRefresh.sortColumns = null
            }
        }
        //callerType
        let reqDrillThruData: any = {}
        reqDrillThruData.dashBoardId = dashBoardId
        reqDrillThruData.vuId = vuId
        reqDrillThruData.vuTempId = vuTempId
        reqDrillThruData.cellId = cellIdRefresh
        reqDrillThruData.cellValue = cellValueRefresh
        reqDrillThruData.pageSize = pageSize
        reqDrillThruData.pageNumber = pageNumber
        reqDrillThruData.drillThruDP = parsedDPRefresh //i am getting sortColumns as our added new sortColumns
        reqDrillThruData.drillThruSetId = drillThruSetIdRefresh
        reqDrillThruData.drillThruSearchString = drillThruSearchString
        reqDrillThruData.InputSearchList = getFormedSearchInput() //getting all the search inputs
        reqDrillThruData.callerType = callerType
        if (inline && data_is_summary && executeResultData?.ComputedData) {
            let arr = executeResultData.ComputedData
            try {
                mindxes = vuDetails.MeasureList.findIndex(function (x: any) {
                    return (
                        x.MetaDataId == reqDrillThruData.drillThruDP?.meId &&
                        x.DetailId == reqDrillThruData.drillThruDP.vuDeId
                    )
                })
            } catch (err) {
                console.error('error3', err)
            }
            let CurrentMeasure = null

            arr.forEach(function (element: any, index: any) {
                if (measureDataPoint) {
                    element.DataPoint = measureDataPoint[index]
                }

                if (arr.indexOf(element) == mindxes) {
                    CurrentMeasure = element.MeasureName
                } else
                    measureVal1 +=
                        element.MeasureName + '  : ' + ' ' + element.DataPoint + ' &nbsp;  '
            })
            reqDrillThruData.isSummaryReport = true //its inside data_is_summary check 
            reqDrillThruData.MeasureListValue = measureVal1 || '' //empty
            reqDrillThruData.CurrentClickedMeasure = CurrentMeasure || '' //Total orders
        }
        reqDrillThruData.drillThruActionType = 'refresh'
        toggleDrillThruLoader(false, true, callerType)
        drillThruVisualUnitData(reqDrillThruData, 'refresh  ', true, '', ishelprequest, applySort)
    }

    const showDrillThruRefreshStatus = (vuId: number, isInline: boolean) => {
        setShowRefreshStatus((prevState) => ({ ...prevState, display: 'inline-block' }))
    }

    useEffect(() => {
        toggleDrillThruLoader(true, false)
        if (initialPayload) {
            drillThruVisualUnitData(initialPayload, actionMode, false, '', false)
        } else {
            console.error("Fail to launch Drill thru..")
        }
    }, [measureName])

    const EditCopyDrillthruset = () => {
        let drillThruSetId = drillThruReducer?.data.drillThruSetId
        let dts = {
            drillThruSetId: drillThruSetId,
            drillThruSetAction: 'Copy',
            vuId: vuId,
            vuTempId: drillThruObjRef.current.data_vuTempId,
        }
        window.foundationsMDS.showCreateMDSDialog(dts)
    }
    const clearInputSearch = (type: string, MDSColumnId?: any, colIndex?: number) => {
        if (type === 'all') {
            toggleDrillThruLoader(false, true)
            setSearchedTextIDs({})
            const inputs = document.querySelectorAll(`input[id^="React_TxtDrillthruSearchId_"]`)
            inputs.forEach((input) => ((input as HTMLInputElement).value = ''))
            let formedPayload = {...initialPayload}
            formedPayload.drillThruSetId = drillThruSetID
            let currentDrillThruDp = {...formedPayload.drillThruDP} //FP-11955 Keeping realtime setId & sortColumns when user do any of the search operations.
            currentDrillThruDp.sortColumns = getSortColumnSelection()
            formedPayload.drillThruDP = currentDrillThruDp
            drillThruVisualUnitData(formedPayload, 'clear_search', true, '', false)
        } else if (type === 'specific') {
            setSearchedTextIDs((prevState: any) => ({
                ...prevState,
                [MDSColumnId]: '',
            }))
            const input = document.getElementById(
                `React_TxtDrillthruSearchId_${MDSColumnId}_${colIndex}_${vuId}`
            )
            if (input) {
                ; (input as HTMLInputElement).value = ''
            }
        }
    }

    const isDatatypeSearchAllowed = (datatype: string) => {
        switch (datatype) {
            case 'HLText':
            case 'HLSearchList':
            case 'HLList':
            case 'HLCount':
            case 'HLNumber':
                return true
            default:
                return false
            //case "HLBooleanTF":
            //case "HLDecimal":
            //case "HLTime":
            //case "HLDate":
            //case "HLDuration":
            //case "HLMoney":
            //case "HLAge":
            //case "HLPercentage":
            //case "HLAgeDays":
            //case "HLBusinessParameter":
            //case "HLSingleValueReport":
            //case "HLYesNo":
            //case "HLMeasureSet":
        }
    }
    const getDrillThruSearchedText = (
        e: { target: { value: string | number } },
        MDSColumnId: string | number,
        colIndex: number
    ) => {
        setSearchedTextIDs((prevState: any) => ({
            ...prevState,
            [MDSColumnId]: e.target.value,
        }))
    }

    const getFormedSearchInput = () =>{ //FP-12024
        let renderMetaDataMDSColumns: any[] = drillThruReducer?.data.renderMetadata?.mdsColumnData
        let InputSearchList: any[] = []
        let isSearchedIds = Object.keys(searchedTextIDs).length > 0 ? true : false
        if (isSearchedIds && renderMetaDataMDSColumns != null) {
            let MDSColumnKeys = Object.keys(searchedTextIDs)
            renderMetaDataMDSColumns.forEach((itr: any, index: number) => {
                if (MDSColumnKeys?.includes(itr.MDSColumnId)) {
                    let inputValue: string = searchedTextIDs[itr.MDSColumnId]
                    let SearchColumnValues: { MetadataId: number; InputValue: string } = {
                        MetadataId: 0,
                        InputValue: '',
                    }
                    SearchColumnValues.MetadataId = parseInt(itr.MDSColumnId)
                    SearchColumnValues.InputValue = inputValue.replace(/^\s+|\s+$/gm, '')
                    InputSearchList.push(SearchColumnValues)
                }
            })
        }else{
            return undefined
        }
        return InputSearchList
    }

    const drillThruSearchByColumn = () => {
        //search button
        let measureVal1 = ''
        let reqDrillThruData: any = {}
        reqDrillThruData.vuId = vuId
        reqDrillThruData.vuTempId = drillThruObjRef.current.data_vuTempId
        reqDrillThruData.cellId = drillThruObjRef.current.data_drillCellId
        reqDrillThruData.cellValue = drillThruObjRef.current.data_drillCellValue
        reqDrillThruData.pageSize = parseInt(drillThruObjRef.current.data_drillPageSize)
        reqDrillThruData.pageNumber = 1
        reqDrillThruData.drillThruDP = drillThruObjRef.current.data_drillThruDP
        reqDrillThruData.drillThruSetId = drillThruReducer?.data.drillThruSetId
        drillThruObjRef.current.data_isSearched = true
        reqDrillThruData.callerType = FoundationsConstants.enumVUCallerType.Default
        if (data_is_summary) {
            let arr = executeResultData.ComputedData
            if (arr) {
                let mindxes = vuDetails.MeasureList.findIndex(function (x: any) {
                    return (
                        x.MetaDataId == drillThruObjRef.current.data_drillThruDP?.meId &&
                        x.DetailId == drillThruObjRef.current.data_drillThruDP.vuDeId
                    )
                })
                let CurrentMeasure = null

                arr.forEach(function (element: any) {
                    if (arr.indexOf(element) == mindxes) CurrentMeasure = element.MeasureName
                    else
                        measureVal1 +=
                            element.MeasureName + '  : ' + ' ' + element.DataPoint + ' &nbsp;  '
                })

                reqDrillThruData.CurrentClickedMeasure = CurrentMeasure
                reqDrillThruData.isSummaryReport = true
                reqDrillThruData.MeasureListValue = measureVal1
            }
        }

        reqDrillThruData.drillThruActionType = 'dt_search'
        
        reqDrillThruData.InputSearchList = getFormedSearchInput() //moved logic to use in other places as well
        
        toggleDrillThruLoader(false, true)
        if(visibleHeaders.length === 0){
            //Test case, When User searched and no data found in that case,
            //then we are clearing searched text, and calling drillthru api with default payload, 
            //keeping sort columns, drillthru set as it is
            let formedPayload = {...initialPayload}
            formedPayload.drillThruSetId = drillThruSetID
            setSearchedTextIDs({}) //clearing all text fields
            let currentDrillThruDp = {...formedPayload.drillThruDP} //FP-11955 Keeping realtime setId & sortColumns when user do any of the search operations.
            currentDrillThruDp.sortColumns = getSortColumnSelection()
            formedPayload.drillThruDP = currentDrillThruDp
            formedPayload.drillThruActionType = 'dt_search'
            drillThruVisualUnitData(formedPayload, 'clear_search', true, '', ishelprequest)    
        }else{
            drillThruVisualUnitData(reqDrillThruData, 'dt_search', true, '', ishelprequest)
        }
    }

    const parseDrillColumnOrder = (vuId: number) => { //Set View Button
        let sortOrder = drillThruObjRef.current?.mdscorderbyid
        if (sortOrder?.length === 0 || drillThruSetID === null) return
        let vuTempId = drillThruObjRef.current.data_vuTempId
        let reqChangeDrillThruOrder: any = {}
        let measureId = drillThruObjRef.current.data_drillThruDP !== undefined ? drillThruObjRef.current.data_drillThruDP.meId : -1 //FP-9323. Added undefined check.

        reqChangeDrillThruOrder.sortOrder = JSON.stringify(sortOrder)
        reqChangeDrillThruOrder.drillThruSetId = drillThruSetID
        reqChangeDrillThruOrder.vuId = vuId
        reqChangeDrillThruOrder.measureId = measureId
        let metadatadrillthruset: IMetadataDrillThruSet = {
            Id: drillThruSetID,
            drillThruSetColumns: [],
        }
        metadatadrillthruset.Id = drillThruSetID;
        metadatadrillthruset.drillThruSetColumns = sortOrder.map(({ mdscId, ...rest }) => ({
            Id: parseInt(mdscId),
            ...rest
        }));
        callSetViewAPI(metadatadrillthruset).unwrap()
            .then((resp) => {
                if (resp?.statusCode === 200) {
                    refreshDrillThru(vuId, vuTempId, FoundationsConstants.enumVUCallerType.Default, null, false, null, null, true) //Temp vuId are no more in use. A clean up tickect is being filled to clear it's references.
                    FoundationsGenericToaster("success", FoundationsConstants.toastrMessage.setviewsuccess)
                }
            }).catch(err => console.error("error while setting view..", err))
    }

    const exportDrillThru = () => {
        let exportVUDrillDataObj = getDrillThruVUObject()
        exportVUDrillDataObj.vuId = vuId
        exportVUDrillDataObj.vuTempId = drillThruObjRef.current.data_vuTempId
        exportVUDrillDataObj.isAsync = true
        exportVUDrillDataObj.cellId = drillThruObjRef.current.data_drillCellId
        exportVUDrillDataObj.cellValue = cellValue
        exportVUDrillDataObj.pageSize = 1000000
        exportVUDrillDataObj.pageNumber = 1
        exportVUDrillDataObj.drillThruDP = { ...drillThruObjRef.current.data_drillThruDP }
        let sortColumns = [...sortColumnsList]
        if (sortColumns.length > 0) exportVUDrillDataObj.drillThruDP.sortColumns = sortColumns
        exportVUDrillDataObj.drillThruSetId = drillThruReducer?.data.drillThruSetId
        exportVUDrillThruData(exportVUDrillDataObj)
    }

    const exportVUDrillThruData = (exportVUObj: any) => {
        toggleDrillThruLoader(false, true)
        disableButtons(['btnExport'], true)
        let reqExportVUDrillData: any = {
            dashBoardId: dashBoardId,
            vuId: exportVUObj.vuId,
            vuTempId: exportVUObj.vuTempId,
            cellId: exportVUObj.cellId,
            cellValue: exportVUObj.cellValue,
            pageSize: exportVUObj.pageSize,
            pageNumber: exportVUObj.pageNumber,
            drillThruDP: exportVUObj.drillThruDP,
            drillThruSetId: exportVUObj.drillThruSetId,
            drillThruSearchString: undefined,
            InputSearchList: undefined,
            EngineType: "newengine" ////doubt of its usage

        }

        if (vuDataObj !== null) {
            reqExportVUDrillData.drillThruSearchString = drillThruObjRef.current.data_drillThruSearch
            reqExportVUDrillData.InputSearchList = drillThruObjRef.current.data_drillThruSearchObj
        }

        callExportDrillThru(reqExportVUDrillData).unwrap()
            .then((response) => {
                if (response != null) {
                    let responseData = response.data
                    if (responseData != null) {
                        if (response.statusCode == 201) {
                            if (responseData.rowCount > 0) {
                                let exportUrl =
                                    getBaseUrl() +
                                    'API/v3/Drillthru/DownloadCSV?vuId=' +
                                    (reqExportVUDrillData.vuTempId != -1
                                        ? reqExportVUDrillData.vuTempId
                                        : reqExportVUDrillData.vuId) +
                                    '&fileGuid=' +
                                    responseData.fileGuid
                                exportPopupMessage.current = { exportMessage: "Export successfully completed", exportLink: exportUrl, linkText: 'Download csv file' }
                                setShowExportPopup(true)
                            } else {
                                exportPopupMessage.current = { exportMessage: "Sorry, no data to export.", exportLink: "", linkText: "" }
                                setShowExportPopup(true)
                            }
                        } else {
                            exportPopupMessage.current = { exportMessage: "Sorry, something went wrong. Please retry this operation later.", exportLink: "", linkText: "" }
                            setShowExportPopup(true)
                        }
                        disableButtons(['btnExport'], false)
                        toggleDrillThruLoader(false, false)
                    }
                }
            }).catch(err => { console.error("Error calling callExportDrillThru", err) })
    }

    const changeSortColumn = (selectedItems: FoundationsOptionType[]) =>{
        //Apply sort dropdown
        //Disable other option (if selected Asc then Desc option will be disabled)
        disableOppisiteOptions(selectedItems)
        setSelectedSortColumns(selectedItems) //changing format to its default format, avaiding complicacy

        setSortOptionVisible(true)
    }

    const disableOppisiteOptions = (selected: FoundationsOptionType[]) => {
        // Extract selected base keys (e.g., "MRN_11222_mdsc")
        //This function disables opposite sort type of selected function 
        //e.g. If user selects MRN - Ascending , then we need to disable MRN - Descending (because same column can have either sort type cannot be both)
        const selectedKeys = selected.map(opt => opt.value.split('_').slice(0, 3).join('_'));
        const selectedMap = Object.fromEntries(
            selected.map(opt => [opt.value.split('_').slice(0, 3).join('_'), opt.value.endsWith('_asc') ? 'asc' : 'desc'])
        );

        const updatedOptions = sortColList.map(opt => {
            const baseKey = opt.value.split('_').slice(0, 3).join('_');
            const isAsc = opt.value.endsWith('_asc');
            const isDesc = opt.value.endsWith('_desc');

            if (selectedKeys.includes(baseKey)) {
                // Disable the opposite direction, If ascending selected, then disable descending
                if ((selectedMap[baseKey] === 'asc' && isDesc) || (selectedMap[baseKey] === 'desc' && isAsc)) {
                    return { ...opt, disabled: true };
                }
            }
            return { ...opt, disabled: false };
        });
        setSortColList(updatedOptions)
    }

//FP-11666 removesortColumn function removed because its been handled from react-select,disableOppisiteOptions & changeSortColumn

    const setcheckValidation = () => {
        if (sortVal.length == 2) {
            setAppentSortvalidtion(true)
        }
        else {
            setAppentSortvalidtion(false)
        }

        return;
    }

    const createSortDropdown = (SortColumns: ISortColumn[], SortableColumns: any[], vuId: number) => {
        let columnsToSort = [...SortableColumns]
        setSortOptionVisible(false)
        let selectedColumns = SortColumns.map(function (col) {
            return col.MetaDataId
        })
        columnsToSort.sort(function (a, b) {
            if (selectedColumns.indexOf(a.MetaDataId) < 0) {
                return 1
            } else if (selectedColumns.indexOf(b.MetaDataId) < 0) {
                return -1
            }
            return selectedColumns.indexOf(a.MetaDataId) - selectedColumns.indexOf(b.MetaDataId)
        })

        let columnOrderMap: any = {}

        SortColumns.forEach(function (col) {
            columnOrderMap[col.MetaDataId] = col.SortOrder || 'asc'
        })
        let sortSelectDropdown: FoundationsOptionType[] = []
        columnsToSort.forEach(function (column) {
            // only show a column order if the reverse order is not selected
            // FP-11666 Looks current behaviour is not correct and its does not set options correctly after refresh, so code commented
            // if (columnOrderMap[column.MetaDataId] != 'desc') {
            //     sortSelectDropdown.push({
            //         label: column.FieldName + ' - Ascending',
            //         value: `${column.FieldName}_${column.MetaDataId}_${column.SqlAliasName1}_asc`,
            //         selected: false,
            //         disabled: false,
            //         id: column.MetaDataId
            //     })
            // }
            // if (columnOrderMap[column.MetaDataId] != 'asc') {
            //     sortSelectDropdown.push({
            //         label: column.FieldName + ' - Descending',
            //         value: `${column.FieldName}_${column.MetaDataId}_${column.SqlAliasName1}_desc`,
            //         selected: false,
            //         disabled: false,
            //         id: column.MetaDataId
            //     })
            // }
            sortSelectDropdown.push({
                label: column.FieldName + ' - Ascending',
                value: `${column.FieldName}_${column.MetaDataId}_${column.SqlAliasName1}_asc`,
                selected: false,
                disabled: false,
                id: column.MetaDataId
            })
            sortSelectDropdown.push({
                label: column.FieldName + ' - Descending',
                value: `${column.FieldName}_${column.MetaDataId}_${column.SqlAliasName1}_desc`,
                selected: false,
                disabled: false,
                id: column.MetaDataId
            })
        })
        let selectedColumn: any[] = []

        Object.entries(columnOrderMap).forEach(([id, order]) => {
            //this code is used to set default selected sort order on drillthru load
            //we have order set in columnOrderMap object based on that i am getting value of selected column order
            const targetLabelSuffix = order === 'asc' ? ' - Ascending' : ' - Descending';

            const selectedMetadata = sortSelectDropdown.find(
                meta => meta.id === parseInt(id) && meta.label.endsWith(targetLabelSuffix)
            );

            if (selectedMetadata) {
                selectedColumn.push(selectedMetadata);
            }
        });
        setSelectedSortColumns(selectedColumn);
        setSortColList(sortSelectDropdown)
        setShowSortDropDown(true)
    }

    const applyDrillThruOrder = (vuId: number) => {
        //Apply Sort fn
        let sortedCols = getSortColumnSelection()
        let copyData_drillThruDP: IDrillThruDp = drillThruObjRef.current.data_drillThruDP
        copyData_drillThruDP = { ...copyData_drillThruDP, sortColumns: sortedCols }
        updateRefState({ data_drillThruDP: copyData_drillThruDP })
        refreshDrillThru(
            vuId,
            -1,
            FoundationsConstants.enumVUCallerType.Refresh,
            null,
            false,
            copyData_drillThruDP,
            null,
            true
        )
    }

    const firstColumnRef = useRef<HTMLTableCellElement>(null);
    const [firstColumnWidth, setFirstColumnWidth] = useState<number | undefined>(undefined);
    const [visibleHeaders, setVisibleHeaders] = useState<string[]>([]);
    const [visibleColumnInfo, setVisibleColumnInfo] = useState([]);
    const [selectedSortColumns, setSelectedSortColumns] = useState<FoundationsOptionType[]>([])
    useEffect(() => {
        const visible = tHeaders.filter((header, index) => {
            const columnInfo = mdsColumData[index];
            return columnInfo?.hideInDrillThru !== 'True';
        });

        const visibleInfo = mdsColumData.filter(col => col?.hideInDrillThru !== 'True');

        if (DrillThruRefreshed) {
            // Staging the order of columns based on DrillThruTableHeaderOrder   
            // Map MDSColumnId to header
            const idToHeaderMap: { [key: string]: string } = {};
            visibleInfo.forEach((col, index) => {
                idToHeaderMap[col.MDSColumnId] = visible[index];
            });
    
            // Map MDSColumnId to col info
            const idToColInfoMap: { [key: string]: any } = {};
            visibleInfo.forEach((col) => {
                idToColInfoMap[col.MDSColumnId] = col;
            });
    
            // Now reorder based on DrillThruTableHeaderOrder
            const orderedHeaders = DrillThruTableHeaderOrder.map(orderObj => idToHeaderMap[orderObj.mdscId]).filter(Boolean);
            const orderedColInfo = DrillThruTableHeaderOrder.map(orderObj => idToColInfoMap[orderObj.mdscId]).filter(Boolean);

            setVisibleHeaders(orderedHeaders as any);
            setVisibleColumnInfo(orderedColInfo as any);
            
            if (drillThruObjRef.current) {
                drillThruObjRef.current.mdscorderbyid = DrillThruTableHeaderOrder;
            }
        } else {
            setVisibleHeaders(visible as any);
            setVisibleColumnInfo(visibleInfo as any);
        }
    }, [tHeaders, mdsColumData]);

    useEffect(() => {
        const updateWidth = () => {
            if (firstColumnRef.current) {
                const width = firstColumnRef.current.getBoundingClientRect().width;
                setFirstColumnWidth(width);
            }
        };
    
        if (firstColumnRef.current) {
            const observer = new ResizeObserver(updateWidth);
            observer.observe(firstColumnRef.current);
    
            // Update the width immediately
            updateWidth();
    
            return () => observer.disconnect();
        }
    }, [visibleHeaders]);


    const getSortColumnSelection = () => {
        if (selectedSortColumns.length) { //selectedSortColumns is like ["MRN_1001_dmrn_asc"...]
            let colDetails = selectedSortColumns.map(function (col: FoundationsOptionType) {
                let [fieldName, colMetaDataId, colSqlAlias, colOrder]: any = col.value.split('_')
                colMetaDataId = parseInt(colMetaDataId)
                return {
                    FieldName: fieldName,
                    MetaDataId: colMetaDataId,
                    SortOrder: colOrder,
                    SqlAliasName1: colSqlAlias,
                }
            })
            return colDetails
        } else {
            return null
        }
    }

    const handleGlobalSearch = (searchText: string) =>{
        if (!searchText) return

        let drillThruVUObj = {...initialPayload}
        drillThruVUObj.pageNumber = 1;
        drillThruVUObj.drillThruSearchString = searchText
        drillThruVUObj.drillThruSetId = drillThruSetID
        //getting sorted colums
        let currentDrillThruDp = {...drillThruVUObj.drillThruDP}
        currentDrillThruDp.sortColumns = getSortColumnSelection()

        drillThruVUObj.drillThruDP = currentDrillThruDp
        drillThruVUObj.drillThruActionType = 'dt_search'
        drillThruVUObj.InputSearchList = null //clearing Column search both searches cannot be done at a time

        drillThruVisualUnitData(drillThruVUObj, 'dt_search', true, '', ishelprequest)
    }

    const setDrillThruSetDefaultForMeasure = () => {
        //toggleDrillThruLoader(true, true)
        var reqSetDTSetDef: any = {}
        //var vuDataObj = $("#dashboard_vu_" + vuId);
        var isExplore = dataExplore == 'yes' ? true : false
        //var vuTempId = $("#dashboard_vu_" + vuId).data("data_vuTempId");
        reqSetDTSetDef.visualUnitId =
            isExplore && drillThruObjRef.current.data_vuTempId != undefined ? drillThruObjRef.current.data_vuTempId : vuId
        reqSetDTSetDef.drillThruDP = drillThruObjRef.current.data_drillThruDP
        reqSetDTSetDef.drillThruSetId = drillThruSetID
        reqSetDTSetDef.oldDrillThruSetId = oldDrillThruSetID
        reqSetDTSetDef.SortColumns = getSortColumnSelection()

        let sortColumns = getSortColumnSelection()
        if (reqSetDTSetDef.drillThruDP == null) reqSetDTSetDef.drillThruDP = {}
        // if (sortColumns !== null) { //FP-11666 its handled already in drillThruObjRef.current.data_drillThruDP
        //     reqSetDTSetDef.drillThruDP.sortColumns = sortColumns
        // }

        //FP-11666 Steven's recent code removed because we are formed drillThruObjRef.current.data_drillThruDP as per requirement no need of extra check

        toggleDrillThruLoader(false, true)
        callSetDrillThruSetDefaultForMeasure(reqSetDTSetDef).unwrap()
            .then((response) => {
                let responseData = response?.data
                if (responseData) {
                    if (response.statusCode == 204) {
                        let vuTempID =
                            drillThruObjRef.current.data_vuTempId > 0
                                ? drillThruObjRef.current.data_vuTempId
                                : undefined
                        setOldDrillThruSetId(-1) //FP-9658, setting to -1 to ensure api should not call twice, view already refreshed
                        toggleDrillThruLoader(false, false)
                        if (drillThruObjRef.current.data_drillThruMode == 'AFHDrillThru') {
                            refreshDrillThru(
                                vuId,
                                vuTempID,
                                FoundationsConstants.enumVUCallerType.Refresh,
                                null,
                                false,
                                null,
                                'AFHDrillThru'
                            )
                        } else {
                            refreshDrillThru(
                                vuId,
                                vuTempID,
                                FoundationsConstants.enumVUCallerType.Refresh,
                                null,
                                false
                            )
                        }
                        FoundationsGenericToaster(
                            'success',
                            'Assigned the selected drill view for this ' +
                            FoundationsConstants.enumVULabel.SingularLower +
                            ' successfully.'
                        )
                    } else {
                        FoundationsGenericToaster(
                            'error',
                            'Assigning the selected drill view for this ' +
                            FoundationsConstants.enumVULabel.SingularLower +
                            ' failed.Please retry this operation later.'
                        )
                    }
                }


            }).catch(err => console.error("Error calling callSetDrillThruSetDefaultForMeasure", err))
    }

    const createDrillThruTableFromJSON = (
        responseData: any,
        payload: IDrillThruPayloadState,
        resultArray: any[]
    ) => {
        let launcherMode = 'popup'
        let linkSeqList: number[] = []
        let drillThroughDataAsJSON = responseData.drillThroughDataAsJSON

        setDrillThroughDataAsJSON(drillThroughDataAsJSON)
        if (responseData['SortColumns']) {
            setSortColumnsList(responseData['SortColumns'])
        }
        let renderMetaDataMDSColumns = responseData['renderMetadata']['mdsColumnData']
        let mdsData = responseData.renderMetadata?.mdsData
        if(mdsData){
            if(mdsData?.isSearchAllowed === 'True' || mdsData?.isSearchAllowed == 1){
                setEnableGlobalSearch(true)
            }
        }

        const sortColumns: ISortColumn[] = payload.drillThruDP?.sortColumns ?? responseData?.SortColumns ?? [];
        
        if (sortColumns.length) {
            sortColumns.forEach(({ MetaDataId, SortOrder }) => {
                setSortColumnOrder((prev: any) => ({
                    ...prev,
                    [MetaDataId]: SortOrder,
                }));
            });
        }

        window.healthLevelGlobal.getFeatureSecurityList().then((successVal: any) => {
            setFeatureList(successVal)
            // var rowCounter = 0;
            // var colCounter = 0;
            // var tableHeading = [];
            // var renderMetaDataMDSColumns = responseData['renderMetadata']['mdsColumnData'];
            // var workListDisplayOrder = JSON.parse(window.unicornInstance.readCookie("mdscorderSequences")) || {};
            // var newdrillThroughDataAsJSON = {};
            // var mdsSeq = workListDisplayOrder["" + payload.vuId + "_" + payload.drillThruSetId];
            // var newRenderMetaDataMDSColumns = [];
        })

        const formedObject: any = transformColumns(renderMetaDataMDSColumns)
        setMDSColumnByColName(formedObject)

        Object.keys(drillThroughDataAsJSON).some((rowKey) => {
            const jsonRow = drillThroughDataAsJSON[rowKey] as Record<string, any> // Assert that jsonRow is an object with string keys
            Object.keys(jsonRow).forEach((colKey) => {
                if (colKey !== 'TotalRows') {
                    const index = renderMetaDataMDSColumns.findIndex(
                        (col: any) => col.columnName === colKey
                    )
                    if (index !== -1) {
                        linkSeqList.push(index)
                    }
                }
            })
            return true // Break after first row
        })

        if (responseData.SortableColumns && responseData.SortableColumns.length > 0) {
            let sortedcolumnname = responseData?.SortColumns.map(function (col: {
                FieldName: string
            }) {
                return col.FieldName
            }).join(', ')
            setSortedColumnName(sortedcolumnname)
        }
        setDrillThruLinkSeqList(linkSeqList)

        if (responseData.ishelprequest == true) {
            //handle afh drill thru here
        }

        let formedPaginationStr: number | string = payload.pageNumber
        if (payload.pageNumber > 1) {
            setFirstPage(false)
        } else if (payload.pageNumber == 1) {
            setFirstPage(true)
        }
        if (responseData.DisplayTotalpages == -1) {
            formedPaginationStr = payload.pageNumber
        } else if (responseData.DisplayTotalpages == 1) {
            formedPaginationStr = responseData.DisplayTotalpages + ' of 1'
        } else if (responseData.DisplayTotalpages > 1) {
            formedPaginationStr = payload.pageNumber + ' of ' + responseData.DisplayTotalpages
        }
        if (responseData.DisplayTotalpages == 1) {
            setFirstPage(true)
            setLastPage(true)
        }
        if (Object.keys(drillThroughDataAsJSON).length < payload.pageSize) {
            setLastPage(true)
        }
        else {
            setLastPage(false)
        }
        setPaginationString(formedPaginationStr)
        setDrillThruData(resultArray)
    }

    const toggleDrillThruLoader = (isLoading = false, inlineLoading = false, actionMode = '') => {

        setLoading(isLoading)
        // FP-11019 Handling the opacity of the DrillThru table when the DrillThru is in refresh state.
        if (inlineLoading) {
            setChangeOpacity(0.5) // Set opacity to 0.5 while refreshing
        } else {
            setChangeOpacity(1) // Reset opacity when refresh completes
        }
        if (actionMode ===  FoundationsConstants.enumVUCallerType.AutoRefresh){
            setShowRefreshStatus((prevState) => ({ ...prevState, display: 'inline-block' })); // Show dot
        } else {
            setShowRefreshStatus((prevState) => ({ ...prevState, display: 'none' }));
        }
        setInlineLoader(inlineLoading)
    }

    const unSelectDrillThruRow = (vuId: number | string, drillThruSetId: number | string) => { }
    const updateRefreshStatus = (vuId: number | string, responseStatusCode: string | number) => { }

    const [draggedColumnIndex, setDraggedColumnIndex] = useState<number | null>(null);

    const handleDragStart = (index: number) => {
        setDraggedColumnIndex(index);
    };

    const handleDragOver = (e: React.DragEvent<HTMLTableCellElement>) => {
        e.preventDefault();
    };

    const handleDrop = (index: number) => {
        if (draggedColumnIndex === null) return;

        const updatedColumns = [...tHeaders];
        const updatedMdsColumns = [...mdsColumData]
        const [removedColumn] = updatedColumns.splice(draggedColumnIndex, 1);
        updatedColumns.splice(index, 0, removedColumn);
        // mdsSortSequence[i] = { mdscId: $(this).data("mdscid"), displayOrder: i + 1 };
        const [removedMdsItem] = updatedMdsColumns.splice(draggedColumnIndex, 1);
        updatedMdsColumns.splice(index, 0, removedMdsItem);
        let mdsSortSequence: IMdscOrderById[] = []; // need to do this while saving the view
        updatedMdsColumns.forEach((mdsItr: any, mdsIndex: number) => {
            mdsSortSequence.push({ mdscId: mdsItr?.MDSColumnId, displayOrder: mdsIndex + 1 })
        })
        updateRefState({ mdscorderbyid: mdsSortSequence })
        setMDSColumData(updatedMdsColumns)
        setTheaders(updatedColumns);
        setDraggedColumnIndex(null); // Reset the dragged column index
    };

    const transformColumns = (columns: ImdsColumnKeys[]) => {
        return columns
            .filter((col) => col.hideInDrillThru === 'False' && col.columnName !== 'TotalRows')
            .reduce(
                (acc, col) => {
                    const { columnName, ...rest } = col // Extract columnName and the rest of the object
                    acc[columnName] = rest
                    return acc
                },
                {} as { [key: string]: Omit<ImdsColumnKeys, 'columnName'> }
            )
    }

    const drillThruVisualUnitData = (
        drillThruVUObj: any,
        actionType: string,
        inlineLoading: boolean,
        inlineParentNode = '',
        ishelprequest: boolean,
        applysort = false
    ) => {
        let paylodActionTypes = ['autorefresh', 'dt_search', 'refresh', 'clear_search']
        if(paylodActionTypes.includes(actionType?.toLowerCase())){
            setDisplayRefreshPanel(false)
        }
        if (actionType === 'refresh' || actionType === 'dt_paginate') {
            setOldDrillThruSetId(drillThruVUObj.drillThruSetId)
        }
        if (actionType === 'changedrillthruset') {
            setOldDrillThruSetId(drillThruVUObj.olddrillThruSetId)
        }
        disableButtons(['save'], vuId)

        if (!inline && drillThruVUObj.drillThruDP == null) {
            //For inline, criteria is different.
            setIsDrillThruApplicable(true)
        }

        let reqDrillThruData: any = {}
        if (document.getElementsByClassName('noCachedData').length !== 0) {
            reqDrillThruData.dataCache = false
        } else {
            reqDrillThruData.dataCache = true
        }
        if (drillThruVUObj.drillThruSetId && drillThruVUObj.drillThruSetId != -1) {
            reqDrillThruData.drillThruSetId = drillThruVUObj.drillThruSetId
        }
        //pageSize
        reqDrillThruData.dashBoardId = drillThruVUObj?.dashBoardId
        reqDrillThruData.vuId = drillThruVUObj.vuId
        reqDrillThruData.vuTempId = drillThruVUObj.vuTempId
        reqDrillThruData.cellId = drillThruVUObj.cellId
        reqDrillThruData.cellValue = drillThruVUObj.cellValue
        reqDrillThruData.vudetails_viewerType = drillThruVUObj.vudetails_viewerType
        reqDrillThruData.cellValueseriesName = drillThruVUObj.cellValueseriesName
        reqDrillThruData.cellValuecategoryName = drillThruVUObj.cellValuecategoryName
        reqDrillThruData.pageSize = vuDetails.DrillthruPageSize //FP-12040 Fetching pageSize from VUDetails directly
        reqDrillThruData.pageNumber = drillThruVUObj.pageNumber
        reqDrillThruData.drillThruDP = drillThruVUObj.drillThruDP
        reqDrillThruData.SortColumns = drillThruVUObj?.SortColumns || undefined
        reqDrillThruData.drillThruSearchString = drillThruVUObj.drillThruSearchString
        reqDrillThruData.drillThruActionType = drillThruVUObj.drillThruActionType
        reqDrillThruData.callerType = drillThruVUObj.callerType
        reqDrillThruData.MeasureName = drillThruVUObj?.MeasureName
        if (actionType === 'dt_search' || drillThruObjRef.current.data_isSearched === true) {
            reqDrillThruData.InputSearchList = drillThruVUObj.InputSearchList
        }else{
            setSearchedTextIDs({})
        }
        //currentClickedMeasure
        reqDrillThruData.TotalRows = drillThruReducer?.data?.rowCount
        reqDrillThruData.isSummaryReport = drillThruVUObj?.isSummaryReport
        reqDrillThruData.MeasureListValue = drillThruVUObj?.MeasureListValue
        reqDrillThruData.CurrentClickedMeasure = drillThruVUObj?.CurrentClickedMeasure
        reqDrillThruData.ishelprequest = ishelprequest
        //Stop autorefresh, if it's already on. Useful while jumping pages etc
        if (actionType != 'refresh') {
            // $("#drill_thru_vu_data" + (inline ? ("_" + drillThruVUObj.vuId) : "")).applyFadeIn();
        } else {
            showDrillThruRefreshStatus(drillThruVUObj.vuId, inline)
        }

        // let engtype = engineType?.toLowerCase() == 'no' ? 'oldengine' : 'newengine'
        // reqDrillThruData.EngineType = engtype
        let drillRefObject = {
            data_drillThruMode: ishelprequest ? 'AFHDrillThru' : '',
            data_vuTempId: drillThruVUObj.vuTempId,
            data_drillCellId: drillThruVUObj.cellId,
            data_drillCellValue: drillThruVUObj.cellValue,
            data_drillPageSize: vuDetails.DrillthruPageSize.toString(), //TODO: FP-11694 - Investigate Why this needs to be string.
            data_drillPageNumber: drillThruVUObj.pageNumber,
            data_drillThruSearch: drillThruVUObj.drillThruSearchString,
            data_drillThruDP: drillThruVUObj.drillThruDP,
            mdscorderbyid: [],
        }
        updateRefState(drillRefObject)
        setRequestedDrillThruData(drillThruVUObj)
        callDrillThru(reqDrillThruData)
            .unwrap()
            .then((response: IDrillthruResponse) => {
                if (response.statusCode == 201) {
                    enableButtons()
                    if (!applysort) {
                        setSortVal([]);
                    }
                    //Drillthru auto refresh automatically start in AutoRefresh component once displayRefreshPanel flag is true based on autoRefreshInterval
                    if (response.data.displayMessage !== '') {
                        setStackTraceMessage(response.data.displayMessage)
                        setThrowError(true)
                        toggleDrillThruLoader(false, false)

                    }
                    if (
                        (!reqDrillThruData.isSummaryReport ||
                            reqDrillThruData?.CurrentClickzaedMeasure === undefined || reqDrillThruData?.CurrentClickzaedMeasure) && response.data.displayMessage === ''
                    ) {
                        let responseData = response.data
                        if (responseData) {
                            setDrillThruInfo(responseData?.DrillThruInfo)
                            if (response.statusCode == 201) {
                                setCellValue(responseData.cellValue) //FIXME: sagar    
                                if (
                                    !responseData.drillThroughDataAsJSON || 
                                    Object.keys(responseData.drillThroughDataAsJSON).length === 0
                                ) {
                                    setTheaders([]);                       
                                    toggleDrillThruLoader(false, false);
                                     if (responseData.DisplayTotalpages == 1) {
                                            setFirstPage(true)
                                            setLastPage(true)
                                        }
                                     setPaginationString('1 of 1') //Hardcoding this line as createDrillThruTableFromJSON method is not called and it handles all pagination related things. In case of page with "no data" it'll be always 1 of 1.  

                                    return;
                                }                         
                                if (responseData.DrillThruSets) {
                                    //Form drillthru set options according to React-Select library
                                    let formedDillThruSetOptions: FoundationsOptionType[] = []
                                    let currentDrillthruSetId = responseData?.drillThruSetId ? responseData?.drillThruSetId : drillThruVUObj?.drillThruSetId
                                    if(responseData.DrillThruSets.length > 0){
                                        responseData.DrillThruSets.forEach((itr: {"Id": number, 
                                            SetName: string,
                                            IsSystemDefault: boolean
                                        })=>{
                                            formedDillThruSetOptions.push({label: itr.SetName, value: itr.Id.toString(), selected: itr.IsSystemDefault, disabled: false})
                                            if(currentDrillthruSetId === itr.Id){
                                                setSelectedDrillThruSet([{label: itr.SetName, value: itr.Id.toString(), selected: itr.IsSystemDefault, disabled: false}])
                                            }
                                        })
                                    }
                                    setDrillThruSets(formedDillThruSetOptions)
                                    setDrillThruSetID(responseData.drillThruSetId)
                                }
                                let firstObj = response?.data?.drillThroughDataAsJSON['0'] //to form table headings
                                if (response?.data?.drillThroughDataAsJSON['0']) {
                                    let resultObject = Object.entries(
                                        response?.data?.drillThroughDataAsJSON
                                    )
                                    const resultArray = resultObject.map(([_, obj]) => obj)

                                    setMDSColumData(responseData['renderMetadata']['mdsColumnData'])
                                    createDrillThruTableFromJSON(
                                        responseData,
                                        reqDrillThruData,
                                        resultArray
                                    )
                                    setTheaders(Object.keys(firstObj).filter((item: any) => item !== 'TotalRows'))
                                    toggleDrillThruLoader(false, false, 'from response')
                                    if (
                                        responseData.drillThruSetId !== -1 &&
                                        drillThruVUObj.drillThruSetId == -1
                                    ) {
                                        drillThruVUObj.drillThruSetId = responseData.drillThruSetId // set id if on the default
                                        // gauge_worklist_block_ display flex
                                        //toggleSideBarHandle_ display flex
                                        //td #td_' + drillThruVUObj.cellId remove class noCachedData
                                    }
                                    // let renderMode = (responseData.renderMetadata?.mdsData?.renderMode == null || responseData.renderMetadata.mdsData?.renderMode == "") ? "1" : responseData.renderMetadata.mdsData?.renderMode;
                                    // responseData.renderMetadata.mdsData.renderMode = renderMode;
                                    if (
                                        responseData.renderMetadata != null &&
                                        Object.keys(responseData.renderMetadata).length > 0 &&
                                        parseInt(responseData.renderMetadata.mdsData.renderMode) ==
                                        0
                                    ) {
                                        // $("#drill_thru_vu_data" + (inline ? ("_" + drillThruVUObj.vuId) : "")).html(responseData.drillThruDataAsHtml);
                                    } else {
                                        var selectedRowIndex = -1
                                        // if ($("#vu_table_drill_" + drillThruVUObj.vuId).find("tr.selected").length) {
                                        //   //selectedRowIndex = $("#vu_table_drill_" + drillThruVUObj.vuId).find("tr.selected")[0].dataset.rowindex;
                                        // }
                                        //TODO:createDrillThruTableFromJSON(drillThruVUObj, responseData, $("#drill_thru_vu_data" + (inline ? ("_" + drillThruVUObj.vuId) : "")), inline);

                                        if (selectedRowIndex > -1) {
                                            var rowData =
                                                responseData.drillThroughDataAsJSON[
                                                selectedRowIndex
                                                ]
                                            //TODO:selectDrillThruRow($("#vu_table_drill_" + drillThruVUObj.vuId), selectedRowIndex, rowData, reqDrillThruData, responseData['renderMetadata']['mdsColumnData'], responseData["SortColumns"]);
                                        }
                                        setTimeout(function () {
                                            if (!inline) {
                                                // var $drillThruWindow = $('#drill_thru_vu_dialog_wrapper' + (inline ? ("_" + drillThruVUObj.vuId) : ""));
                                                var option = {
                                                    width: '90%',
                                                    position: {
                                                        my: 'center',
                                                        at: 'center',
                                                        of: window,
                                                    },
                                                }
                                                // $('.ui-dialog-buttonset').removeClass('hide');

                                                //TODO: headerfixed("#vu_table_drill_" + drillThruVUObj.vuId);
                                                let invalidActionModes: string[] = [
                                                    'refresh',
                                                    'dt_search',
                                                    'dt_paginate',
                                                    'changedrillthruset',
                                                ]
                                                if (
                                                    responseData.renderMetadata.mdsData
                                                        .renderMode == 1 &&
                                                    !invalidActionModes?.includes(actionType)
                                                ) {
                                                    //TODO: insertAdditionalButtons(responseData, $(".ui-dialog-buttonpane"));
                                                }
                                                //TODO: displayDrillThruTotalTime(startTime, ajaxEndTime, new Date().getTime(), responseData.rowCount);
                                            }
                                            // $("#btnRefresh").focus();
                                            if (buttonRef.current) {
                                                buttonRef.current.focus()
                                            }
                                        }, 0)
                                        //TODO: setDrillThruSearchEvents(reqDrillThruData, inline);
                                        //TODO: setDrillThruSearchByColumnEvents(reqDrillThruData, inline)
                                    }

                                    if (
                                        responseData.SortableColumns &&
                                        responseData.SortableColumns.length > 0 &&
                                        dataExplore != 'yes' &&
                                        ((vuDetails !== undefined &&
                                            !vuDetails?.AppGUID) ||
                                            ishelprequest) //FP-9323. Added undefined check. FP-9339. Added ishelprequest check for AFH
                                    ) {
                                        //FIXME: check if required..
                                        createSortDropdown(
                                            responseData.SortColumns,
                                            responseData.SortableColumns,
                                            drillThruVUObj.vuId
                                        )
                                    }
                                } else if (
                                    ['FoundationsSystemAdmin', 'SystemAdmin'].indexOf(currentUserData.type) > -1
                                    &&
                                    responseData.displayMessage
                                ) {
                                    if (
                                        drillThruVUObj.callerType !=
                                        FoundationsConstants.enumVUCallerType.AutoRefresh
                                    ) {
                                        if (inline && data_is_summary && dataExplore == 'yes') {
                                            //$("#vu_drillthru_wrapper_" + drillThruVUObj.vuId).html(drillthruBackButtonHTML + `
                                            // <div className='padding-small'>${responseData.displayMessage}</div>
                                            // `);
                                            // if a summary in normal view mode
                                        } else if (inline && data_is_summary) {
                                            var oldVUData = vuDetails
                                            updateRefState({ data_vuDetails: oldVUData })
                                        } else if (inline) {

                                        }
                                    }
                                }
                                if (autoRefreshInterval > 0) {
                                    setDisplayRefreshPanel(true)
                                }
                            }
                        }
                    }

                } 
                toggleDrillThruLoader(false, false, drillThruVUObj.callerType)
                setShowRefreshStatus((prevState) => ({ ...prevState, display: 'none' }))
            })
            .catch((err) => {
                console.error('error at drillThruVisualUnitData', err), toggleDrillThruLoader(false, false)
            })
    }
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogProps, setDialogProps] = useState<any>(null);

    // Callback to open OCVDialog
    const openOCVDialog = (props: any) => {
        setDialogProps({
            ...props,
            onClose: () => setIsDialogOpen(false) // Ensure onClose closes dialog
        });
        setIsDialogOpen(true);
    };

    const LinkSetUpCallBackValues = (callbackValues: any) => {
        if (callbackValues.setLmsId) {
            dispatch(setLmsId(Number(callbackValues.setLmsId)));
            dispatch(setnewForm(false));
        } else if (callbackValues.action === 'VIEW' && callbackValues.setStatPortalId) {
            setStatPortalId(callbackValues.setStatPortalId);
            setSelectedVuId(callbackValues.SelectedVuId);
            forceUpdate();
        } else if (callbackValues.action === 'RELEASE' && callbackValues.SelectedAccessionNumber) {
            setSelectedAccessionNumber(callbackValues.SelectedAccessionNumber);
            setSelectedVuId(callbackValues.SelectedVuId);
            setAction('RELEASE');
        } else if (callbackValues.action === 'CLAIM' && callbackValues.SelectedAccessionNumber) {
            setSelectedAccessionNumber(callbackValues.SelectedAccessionNumber);
            setSelectedVuId(callbackValues.SelectedVuId);
            setAction('CLAIM');
        } else {
            openOCVDialog(callbackValues);
        }
    };

    const tableRef = useRef<HTMLTableElement>(null);
    const pageContainerRef = useRef<HTMLDivElement>(null);
    useStickyHeader(tableRef, pageContainerRef);

    const theadRef = useRef<HTMLTableRowElement | null>(null);
    const tbodyRef = useRef<HTMLTableSectionElement | null>(null);
    const [cellRefs, setCellRefs] = useState<React.RefObject<HTMLTableCellElement>[][]>([]);

    useEffect(() => {
        if (drillThruData?.length && visibleHeaders.length) {
            const refsMatrix = drillThruData.map(row =>
                visibleHeaders.map(() => React.createRef<HTMLTableCellElement>())
            );
            setCellRefs(refsMatrix);
        }
    }, [drillThruData, visibleHeaders]);

    // below are values that are passed in context to child components
    const [draggedColIndex, setDraggedColIndex] = useState<number | null>(null);
    const DrillThruTableConetextValues = {
        draggedColIndex,
        setDraggedColIndex,
    }

    useEffect(() => {

        // FP-11829 If high text drillthru is ON, don't enable column dragging
        if (toggleDrill) return;

        // Initialize the sortable functionality for column headers and move corresponding column data
        const table = tableRef.current;

        if (table) {

            const thead = theadRef.current;
            const tbody = tbodyRef.current

            if (thead && tbody) {
                const sortable = Sortable.create(thead as HTMLElement, {
                    group: 'nested',
                    handle: 'th',
                    animation: 150,
                    onStart(evt) {
                        const columnName = evt.item?.getAttribute('data-column-name');
                        if (columnName) {
                            const colIndex = visibleHeaders.indexOf(columnName);
                            if (colIndex !== undefined) {
                                setDraggedColIndex(colIndex);
                        }
                    }
                    },
                    onEnd(evt) {
                        // 1. Update visibleHeaders array with new column order
                        const newOrder = [...visibleHeaders];
                        if (evt.oldIndex !== undefined && evt.newIndex !== undefined) {
                            const movedHeader = newOrder.splice(evt.oldIndex, 1)[0];
                            newOrder.splice(evt.newIndex, 0, movedHeader);
                            setVisibleHeaders(newOrder);
                        }

                        // 2. Reorder the cellRefs to match new column order
                        const updatedCellRefs = cellRefs.map(rowRefs => {
                            const updatedRow = [...rowRefs];
                            if (evt.oldIndex !== undefined && evt.newIndex !== undefined) {
                                const movedRef = updatedRow.splice(evt.oldIndex, 1)[0];
                                updatedRow.splice(evt.newIndex, 0, movedRef);
                            }
                            return updatedRow;
                        });
                        setCellRefs(updatedCellRefs);
                        let mdsSortSequence: IMdscOrderById[] = [];
                        newOrder.forEach((header: string, index: number) => {
                            const columnData = mdsColumData.find(col => col.columnName === header);
                            if (columnData) {
                                mdsSortSequence.push({
                                    mdscId: columnData.MDSColumnId,
                                    displayOrder: index + 1
                                });
                            } else {
                                console.warn(`No matching column data found for header with name: ${header}`);
                            }
                        });
                        updateRefState({ mdscorderbyid: mdsSortSequence });
                        setDraggedColIndex(null);
                    },

                });

                Sortable.create(tbody, {
                    group: {
                        name: 'columns',
                        pull: false,
                        put: false
                    },
                    sort: false,
                    animation: 150,
                    onEnd(evt) {
                        // Similar logic to update column order after reordering rows
                    },
                });
            }
        }
        return () => {
            // Cleanup the sortable functionality when the component unmounts
            const table = tableRef.current;
            if (table) {
                const thead = theadRef.current;
                const tbody = tbodyRef.current
                const sortableInstance = Sortable.get(thead as HTMLElement);
                const sortableBodyInstance = tbody ? Sortable.get(tbody) : null;

                if (sortableInstance) {
                    sortableInstance.destroy();
                }
                if (sortableBodyInstance) {
                    sortableBodyInstance.destroy();
                }
            }
        };
    }, [cellRefs, visibleHeaders, toggleDrill]); // Re-run this when visibleHeaders changes

    const getCurrentColumnOrder = (): IMdscOrderById[] => {
        return visibleHeaders
            .map((header, index) => {
                const col = mdsColumData.find(c => c.columnName === header);
    
                // Ensure only valid columns are returned and match the expected type
                if (col) {
                    return {
                        mdscId: col.MDSColumnId, // Assuming MDSColumnId is a string
                        displayOrder: index + 1,   // The position of the column in the visible order
                    };
                }
    
                // If the column is not found, we return null, which will be filtered out later
                return null;
            })
            .filter((item): item is IMdscOrderById => item !== null); // Filter out null values
    };
    
    
    const handleRefresh = () => {
        // 1. Get the current column order using the helper function
        const currentOrder = getCurrentColumnOrder();
        setDrillThruTableHeaderOrder(currentOrder)
        setDrillThruRefreshed(true)
    
        // 2. Call the refresh function
        refreshDrillThru(
            vuId,
            drillThruObjRef.current.data_vuTempId,
            FoundationsConstants.enumVUCallerType.Refresh,
            [],
            true
        );
    };

    useEffect(() => {
        if (!loading && onDrillThruLoaded) {
            onDrillThruLoaded(); // Notify that DrillThru is fully loaded
        }
    }, [loading]);

    return (
        <>
        <DrillThruTableConetext.Provider value={DrillThruTableConetextValues}>

            {/* Export popup */}
            <HandleAnyPopupMessage
                isOpen={showExportPopup}
                title="Export Data"
                message={exportPopupMessage.current.exportMessage}
                onClose={() => setShowExportPopup(false)}
                Link={exportPopupMessage.current.exportLink}
                linkText={exportPopupMessage.current.linkText}
            />

            {/* Main content */}
            <div
                id={'vu_drillthru_wrapper_' + vuId}
                className={throwError ? 'vu_table_stack_trace vu-drillthru-wrapper w-100' : 'vu-drillthru-wrapper w-100'}
                style={{
                    opacity: loading && !inlineLoader && !throwError ? 0 : 1,
                    borderBottom: !initialPayload?.isSummaryReport ? '1px solid gray' : 'none'
                }}
            >
                <div
                    id={'React_drill_thru_container_' + vuId}
                    className="nohover"
                    style={{ paddingRight: '0px', paddingBottom: '0px', paddingLeft: '0px' }}
                >
                    {throwError ? (
                        // Error state - Show ReportStackTraceBlock
                        <ReportStackTraceBlock
                            vuid={vuId}
                            stylesForReport={{
                                border: '1px solid gray',
                                transition: '.5s linear, .5s opacity linear',
                                overflow: 'hidden',
                                opacity: 1
                            }}
                            isSummary={initialPayload?.isSummaryReport}
                            closeDrillThru={closeDrillThru}
                            stackTraceMessage={stackTraceMessage}
                        />
                    ) : !loading && (
                        // </div>
                        <>
                            <div
                                id={'React_drill_thru_vu_info_' + vuId}
                                className="vu-drill-info"
                                style={{ display: data_is_summary && 'block' }}
                            >
                                <span className="value">
                                    <span className="highlightMeasureVAl">
                                        {Object.keys(drillThruInfo)?.length > 0 &&
                                            Object.entries(drillThruInfo).map(([key, value], index, array) => (
                                                <React.Fragment key={key}>
                                                    <span>{key}</span>:
                                                    <span className='value ml-2'>{value as string}</span>                                                
                                                </React.Fragment>
                                            ))}
                                    </span>
                                </span>
                                {showRefreshStatus.display === 'inline-block' && (
                                    <span id={'refresh_status_' + vuId} style={{ ...showRefreshStatus } as {}}>
                                        •
                                    </span>
                                )}
                                {displayRefreshPanel && (
                                    <AutoRefreshTimer vuid ={vuId} refreshInterval={autoRefreshInterval} onRefresh={refreshDrillThru} drillThruObjRef = {drillThruObjRef.current}/>
                                )}
                                <div className={data_is_summary ? 'close close-actionlist' : 'close-table-drillthru'}
                                    onClick={closeDrillThru}
                                >
                                    {data_is_summary ? 'X' : '← Go back to Report'}
                                </div>
                            </div>
                            {!isDrillThruApplicable ? (
                                <div className="padding-small">
                                    Drill thru' is not applicable for this information.{' '}
                                </div>
                            ) : (
                                <div
                                    id={'React_drill_thru_vu_data_' + vuId}
                                    style={{
                                        display: 'block',
                                        minHeight: '10px',
                                        opacity: changeOpacity,
                                        transition: 'opacity 0.5s ease',
                                    }}
                                >
                                    <div
                                        id={'React_vu_table_drill_wrapper_' + vuId}
                                        className="vu-table-drill-wrapper"
                                        style={{ display: 'flex', flexDirection: 'row' }}
                                        ref={pageContainerRef}
                                    >
                                        <table
                                            id={'React_vu_table_drill_' + vuId}
                                            className={
                                                toggleDrill
                                                    ? 'vu-table-drill hover-highlight focus-drillthru'
                                                    : 'vu-table-drill hover-highlight'
                                            }
                                            style={{ borderCollapse: 'collapse',}}
                                            ref={tableRef}
                                        >
                                            <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
                                                <tr ref={theadRef} className="vu-table-drill-header">
                                                    {visibleHeaders.map((header, visibleIndex) => {
                                                        const originalIndex = tHeaders.indexOf(header);
                                                        const columnInfo = mdsColumData[originalIndex];

                                                        let sortArrow = '';
                                                        let sortColOrder = { ...sortColumnOrder };

                                                        if (Object.keys(sortColOrder).length > 0) {
                                                            sortArrow = sortColOrder[columnInfo?.MetadataId] != null
                                                                ? sortColOrder[columnInfo?.MetadataId] == 'asc'
                                                                    ? '\u25B2'
                                                                    : '\u25BC'
                                                                : '';
                                                        }

                                                        return (
                                                            <th
                                                                id={`vu_col_${vuId}_${header}`}
                                                                className="left"
                                                                data-column-name={header}
                                                                key={header}
                                                                data-column-id={originalIndex}
                                                                ref={visibleIndex === 0 ? firstColumnRef : null}
                                                                style={{
                                                                    ...(visibleIndex === 0 ? { left: 0, zIndex: 4 } : {}),
                                                                    ...(visibleIndex === 1 ? { left: `${firstColumnWidth}px`, zIndex: 3 } : {})
                                                                }}
                                                            >
                                                                {sortArrow ? header + ' ' + sortArrow : header}
                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody ref={tbodyRef}>
                                                {drillThruData?.map((row: any, index: number) => { //Actual rows are mapped to form single cell of Drillthru table 
                                                    
                                                    let [
                                                        jsonRow,
                                                        jsonRowList,
                                                        jsonRowEncrypyedList,
                                                        sortColumnsData,
                                                    ] =
                                                        getJSONRowDataLists(
                                                            drillThruDataAsJson[index],
                                                            sortColumnsList
                                                        )

                                                    return (
                                                        <tr
                                                            onClick={() =>
                                                                openHighTextDrillRow(row, index, {
                                                                    jsonRowList: jsonRowList,
                                                                    jsonRowEncrypyedList:
                                                                        jsonRowEncrypyedList,
                                                                    sortColumnsData: sortColumnsData,
                                                                    featureList: featureList,
                                                                })
                                                            }
                                                            className={
                                                                activeDrillRow === index
                                                                    ? 'vu-table-drill-row selected openDrill'
                                                                    : 'vu-table-drill-row openDrill'
                                                            }
                                                            title="Click to expand row"
                                                            key={index}
                                                        >
                                                            {
                                                                visibleHeaders.map((header, visibleIndex) => { //After row Map, its mapping every drillthru table
                                                                    const originalIndex = tHeaders.indexOf(header);
                                                                    const cellRef = cellRefs[index]?.[visibleIndex];
                                                                    const columnInfo = mdsColumData[originalIndex];
                                                                    let cellValue = row[header];
                                                                    if (columnInfo?.dataType === 'HLDuration' && cellValue != null && cellValue !== '') {
                                                                        cellValue = getDurationDisplayFromSecs(cellValue);
                                                                    }
                                                                    return (
                                                                        <LinkSetup
                                                                            headerText={header}
                                                                            rowObject={row}
                                                                            valText={cellValue as string} //this is actual Cell Text of drillthru row
                                                                            JSONRowDataLists={{
                                                                                featureList: featureList,
                                                                                jsonRowEncrypyedList: jsonRowEncrypyedList,
                                                                                sortColumnsData: sortColumnsData,
                                                                                jsonRowList: jsonRowList
                                                                            }}
                                                                            vuId={vuId}
                                                                            mdsColumnData={drillThruReducer?.data.renderMetadata?.mdsColumnData}
                                                                            formedColumn={mdsColumnByColName}
                                                                            tableHeading={tHeaders}
                                                                            rowCounter={originalIndex + 1}
                                                                            colCounter={visibleIndex} //  getting colCounter as undefined.
                                                                            firstColumnWidth={firstColumnWidth} // Pass as a prop
                                                                            launcherMode={"popup"}
                                                                            drillThruVUObj={requestedDrillThruData}
                                                                            data_drillThruSearchObj={drillThruObjRef.current.data_drillThruSearchObj}
                                                                            data_isEnabledAutoNavigation={isEnabledAutoNavigation}
                                                                            set_drillThruComponentType={DrillThruComponentType.DrillThruTableRow}
                                                                            cellRef={cellRef}
                                                                            LinkSetUpCallBack={LinkSetUpCallBackValues}
                                                                        />
                                                                    )
                                                                })}
                                                        </tr>
                                                    )
                                                })}
                                                {!loading && visibleHeaders.length === 0 && (
                                                    <tr className="vu-table-drill-row vu-drill-zero-data">
                                                        {' '}
                                                        <td>No Data Found</td>
                                                    </tr>
                                                )}
                                                <tr className="vu-table-drill-row col-search-row">
                                                    {visibleHeaders.map((header, visibleIndex) => { //This is for Column Search Text
                                                        const originalIndex = tHeaders.indexOf(header);
                                                        const MDSColumn = mdsColumData[originalIndex]; //FP-12024 fetching it from drillThruReducer, Causing disappearing the search fields.

                                                        return (
                                                            <td
                                                                key={`search-${visibleIndex}`}
                                                                className="left"
                                                                style={{
                                                                    ...(visibleIndex === 0
                                                                        ? { position: 'sticky', left: '0px', zIndex: 4 }
                                                                        : visibleIndex === 1
                                                                            ? { position: 'sticky', left: '100px', zIndex: 3 }
                                                                            : {}),
                                                                }}
                                                            >
                                                                {MDSColumn &&
                                                                    MDSColumn.hideInDrillThru !== '' &&
                                                                    MDSColumn.hideInDrillThru !== 'True' &&
                                                                    isDatatypeSearchAllowed(MDSColumn?.dataType) &&
                                                                    MDSColumn.columnName !== 'TotalRows' && (
                                                                        <div className="search-container">
                                                                            <span className="deleteicon">
                                                                                <input
                                                                                    value={searchedTextIDs[MDSColumn.MDSColumnId] || ''}
                                                                                    type="text"
                                                                                    className={`REact_DrillthruSearchTextBox_${vuId}`}
                                                                                    id={`React_TxtDrillthruSearchId_${MDSColumn.MDSColumnId}_${visibleIndex}_${vuId}`}
                                                                                    onChange={(e) =>
                                                                                        getDrillThruSearchedText(e, MDSColumn.MDSColumnId, visibleIndex)
                                                                                    }
                                                                                />
                                                                                <span
                                                                                    onClick={() =>
                                                                                        clearInputSearch('specific', MDSColumn.MDSColumnId, visibleIndex)
                                                                                    }
                                                                                    className="clear_search_cross"
                                                                                ></span>
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            </tbody>
                                        </table>
                                        {toggleDrill && (
                                            <span
                                                id={'React_focus_drill_details_' + vuId}
                                                style={{ display: 'block', width: '100%' }}
                                                className="focus-drillthru-details"
                                            >
                                                <div className="top-section">
                                                    {Object.entries(drillData).map(
                                                        ([key, value], index) => {
                                                            return (
                                                                <LinkSetup
                                                                    headerText={key}
                                                                    valText={value as string}
                                                                    rowObject={drillData}
                                                                    JSONRowDataLists={JSONRowDataLists}
                                                                    vuId={vuId}
                                                                    mdsColumnData={
                                                                        drillThruReducer?.data.renderMetadata?.mdsColumnData
                                                                    }
                                                                    formedColumn={mdsColumnByColName}
                                                                    tableHeading={tHeaders}
                                                                    rowCounter={activeDrillRow}
                                                                    colCounter={index}
                                                                    drillThruVUObj={
                                                                        requestedDrillThruData
                                                                    }
                                                                    data_drillThruSearchObj={
                                                                        drillThruObjRef.current.data_drillThruSearchObj
                                                                    }
                                                                    data_isEnabledAutoNavigation={
                                                                        isEnabledAutoNavigation
                                                                    }
                                                                    set_drillThruComponentType={DrillThruComponentType.HighlightDrillThru}
                                                                    LinkSetUpCallBack={LinkSetUpCallBackValues}
                                                                />
                                                            )
                                                        }
                                                    )}
                                                </div>
                                                <div className="bottom-section"></div>
                                                <span className="close-focus-drillthru float-right cursor-pointer">
                                                    <a onClick={() => setToggleDrill(false)}>Close</a>
                                                </span>
                                            </span>
                                        )}
                                    </div>
                                    <div
                                        id={'React_vu_drill_paging_wrapper_' + vuId}
                                        className="vu-paging-wrapper"
                                    >
                                        {drillThruSets.length !== 0 && (
                                            <div
                                                id={'React_vu_drill_set_list_' + vuId}
                                                className="left mr-3"
                                            >
                                                {/* <select onChange={() => changeDrillThruSet()} title='Select the data set list' className='select2-hidden-accessible' style={{ display: 'inline-block' }} id={"React_vu_drill_thru_set_" + vuId}> */}
                                                <span title={`${selectedDrillthruSet.length ? selectedDrillthruSet[0].label : 'Select the data set list'}`}>
                                                    {/* Cannot use FoundationsSelect because its not implemented for single select */}
                                                    {/* If i implemented under FoundationsSelect multiple things will get changed lead to bugs in other places as well so using another component */}
                                                    {/* FP-11666 */}
                                                    <ReactSelectDropdown
                                                        styleProps={currentUserData.DisplayMode === FoundationsConstants.DisplayMode.Night ? ReactSelect_DarkMode : ReactSelect_LightMode}
                                                        options={drillThruSets}
                                                        multiple={false}
                                                        id={'vu_drill_thru_set_' + vuId}
                                                        onChange={(result : FoundationsOptionType | FoundationsOptionType[])=>changeDrillThruSet(result as FoundationsOptionType)}
                                                        menuPlacement={'auto'}
                                                        isClearable={false}
                                                        value={selectedDrillthruSet} //value should be whole object that comes from library's default Event
                                                        />
                                                </span>
                                            </div>
                                        )}
                                        {showSortDropDown && (
                                            <>
                                            {/* Multi select */}
                                                <span className='left mr-3' title='Select sorting columns (Max 2 columns, Can save order by clicking Make Default)'>
                                                    <FoundationsSelect
                                                        selectCustomStyles={currentUserData.DisplayMode === FoundationsConstants.DisplayMode.Night ? ReactSelect_DarkMode : ReactSelect_LightMode}
                                                        options={sortColList}
                                                        isMultiSelect={true}
                                                        placeHolder='-Select a column-'
                                                        id={''}
                                                        onChange={changeSortColumn}
                                                        value={selectedSortColumns}
                                                        menuPlacement={'top'}
                                                    />
                                                </span>
                                                {sortOptionVisible && (
                                                    <a
                                                        id={'React_apply_sort_' + vuId}
                                                        className="cursor-pointer mr-2"
                                                        onClick={() => applyDrillThruOrder(vuId)}
                                                    >
                                                        {' '}
                                                        Apply Sort
                                                    </a>
                                                )}
                                                <span
                                                    id={'selectedColumns_' + vuId}
                                                    style={{
                                                        color: '#999',
                                                        fontSize: '12px',
                                                        lineHeight: '2',
                                                    }}
                                                >
                                                    Sorted by {sortedColumnName}
                                                </span>
                                            </>
                                        )}
                                        <div className="right drill-footer-right-container">
                                            {inlineLoader && (
                                                <span
                                                    id={'vu_drill_paging_loading_' + vuId}
                                                    style={{ display: 'inline-block' }}
                                                    className="drill-footer-loader"
                                                >
                                                    <span
                                                        id={'React_ajax-loading-box-' + vuId}
                                                        className="ajax-loading-box"
                                                    >
                                                        <span className="ajax-loading-image"></span>
                                                        Loading...
                                                    </span>
                                                </span>
                                            )}
                                            <a
                                                onClick={() => clearInputSearch('all')}
                                                id={'React_ClearSearchInputLink_' + vuId}
                                                className="cursor-pointer"
                                            >
                                                Clear Search&nbsp;
                                            </a>
                                            <span
                                                className={firstPage ? 'disabled' : ''}
                                                onClick={() =>
                                                    !firstPage
                                                        ? jumpDrillPage(vuId, 'previous', inline)
                                                        : ''
                                                }
                                                title={!firstPage ? 'Previous set of rows' :'Already on first page'}

                                                id={
                                                    'React_vu_drill_jump_page_previous_' +
                                                    vuId +
                                                    'disabled'
                                                }
                                            >
                                                <img
                                                    src={getBaseUrl() + '/images/prev.png'}
                                                    className="prev"
                                                    style={{ cursor: 'pointer' }}
                                                    alt=""
                                                />
                                            </span>
                                            <span className="padding-left-small"> Page</span>
                                            <span className="padding-left-small padding-right-small">
                                                {' '}
                                                {paginationString}
                                            </span>
                                            <span
                                                className={lastPage ? 'disabled' : ''}
                                                onClick={() =>
                                                    !lastPage ? jumpDrillPage(vuId, 'next', inline) : ''
                                                }
                                                id={'React_vu_drill_jump_page_next_' + vuId}
                                                title={!lastPage ?  'Next set of rows' :'Already on last page'}
                                                >
                                                <img
                                                    src={getBaseUrl() + '/images/next.png'}
                                                    className="next"
                                                    style={{ cursor: 'pointer' }}
                                                    alt=""
                                                />
                                            </span>
                                        </div>
                                        {
                                            enableGlobalSearch &&
                                            <DrillThruGlobalSearch vuid={vuId} handle_GlobalSearch={handleGlobalSearch}/>
                                        }
                                    </div>
                                </div>
                            )}
                            <div
                                id={'React_drill_thru_vu_buttons_container_' + vuId}
                                className="vu-drill-wrapper px-1 py-1"
                            >
                                <button
                                    onClick={() => closeDrillThru()}
                                    id={`drillthru_button_${vuId}_btnclose`}
                                    className="app-button negative float-right"
                                >
                                    Close{' '}
                                </button>
                                <button
                                    ref={buttonRef}
                                    id={`drillthru_button_${vuId}_btnRefresh`}
                                    className="app-button float-right"
                                    onClick={()=> handleRefresh()}
                                >
                                    Refresh
                                </button>
                                <button
                                    onClick={() => drillThruSearchByColumn()}
                                    id={`drillthru_button_${vuId}_btnSearch`}
                                    className="app-button"
                                >
                                    Search
                                </button>
                                {currentUserData.privileges?.includes('AllowDataExport') && (
                                <button
                                    disabled={buttonState.btnExport}
                                    onClick={() => exportDrillThru()}
                                    id={`drillthru_button_${vuId}_btnExport`}
                                    className="app-button float-right"
                                >
                                    Export
                                </button>
                                )}
                                <button
                                    onClick={() => setDrillThruSetDefaultForMeasure()}
                                    id={`drillthru_button_${vuId}_btnMakeDefault`}
                                    className="app-button float-left"
                                >
                                    Make default
                                </button>
                                <button
                                    onClick={() => parseDrillColumnOrder(vuId)}
                                    id={`drillthru_button_${vuId}_btnSetView`}
                                    className="app-button float-left"
                                >
                                    Set view
                                </button>
                                {(!vuDetails?.AppGUID && currentUserData.privileges?.includes('CreateDrillThruSet')) && (
                                <button
                                    onClick={() => EditCopyDrillthruset()}
                                    id={`drillthru_button_${vuId}_btnEditCopyDts`}
                                    className="app-button float-left"
                                >
                                    Edit or copy
                                </button>
                                )
                                }
                                {
                                drillThruReducer?.data?.DrillthruQuery &&
                                    <span id={'React_summToolTip_' + vuId} className="pl-2 instrumentation">
                                        <span
                                            id={'React_query_image_title1_' + vuId}
                                            className="tooltip-info-link"
                                        >
                                            Drillthru Query
                                        </span>
                                        <DetailedTooltip
                                            tooltipHeading='Sql Query'
                                            targetEl={'React_query_image_title1_' + vuId}
                                            key={'DrillThru_Query' + vuId}
                                            content={drillThruReducer.data.DrillthruQuery}
                                            placement="bottom"
                                            animation="shift-away-subtle"
                                            allowHTML={true}
                                            showIcon={false}
                                            isCopyable
                                            copyText={drillThruReducer.data.DrillthruQuery}
                                            trigger={'mouseenter focus'}
                                            delay={[100, 0]}
                                        />
                                    </span>
                                }
                            </div>
                        </>
                    )}
                </div>
                {/* </div> this is of drillthru_block*/}
            </div>
            {isDialogOpen && <OCVDialog {...dialogProps} />}
            </DrillThruTableConetext.Provider>
        </>
    )
}

export default DrillThru
